(function(){"use strict";
// pide-vicio-premium-search.js v3

var STORAGE="pv-recent-q",MAX_RECENT=6;
var FREE_DEL=((window.PV_SETTINGS&&window.PV_SETTINGS.freeDeliveryThreshold)||50000)*100;
var TRENDING=["Combo Vicio","Alitas BBQ","Crispy","Burger Vicio","Papas"];
var BADGES=["🔥\xA0M\xE1s pedido","⭐\xA0Favorito","🏆\xA0Top ventas","💥\xA0Imperdible"];

function getRecent(){try{return JSON.parse(localStorage.getItem(STORAGE)||"[]")}catch(e){return[]}}
function addRecent(q){if(!q||q.length<1)return;try{var r=getRecent().filter(function(x){return x.toLowerCase()!==q.toLowerCase()});r.unshift(q);localStorage.setItem(STORAGE,JSON.stringify(r.slice(0,MAX_RECENT)))}catch(e){}}
function clearRecent(){try{localStorage.removeItem(STORAGE)}catch(e){}}
function fmtP(p){var n=Math.round(parseFloat(p)||0);return"$"+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,".")}
function fmtC(c){return fmtP((c||0)/100)}
function shopImg(src,w){if(!src)return"";if(src.startsWith("//"))src="https:"+src;var m=src.match(/^(https?:\/\/cdn\.shopify\.com\/[^?]+)\.(jpg|jpeg|png|gif|webp)(\?.+)?$/i);if(m)return m[1]+"_"+w+"x."+m[2]+(m[3]||"");return src}
function escH(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}
function hl(text,q){if(!q)return escH(text);try{return escH(text).replace(new RegExp("("+q.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")+")","gi"),'<mark class="pv-sp-hl">$1</mark>')}catch(e){return escH(text)}}
function catEmoji(t){t=(t||"").toLowerCase();if(t.includes("burger")||t.includes("hambur"))return"🍔";if(t.includes("combo"))return"🎁";if(t.includes("papa")||t.includes("fries")||t.includes("fritas"))return"🍟";if(t.includes("alita"))return"🍗";if(t.includes("crispy")||t.includes("fried"))return"🔥";if(t.includes("gorra")||t.includes("merch"))return"🧢";if(t.includes("promo"))return"💥";if(t.includes("vend")||t.includes("top"))return"⭐";if(t.includes("bebida")||t.includes("cola")||t.includes("gaseo"))return"🥤";return""}

function injectCSS(){
  if(document.getElementById("pv-sp-css"))return;
  var l=document.createElement("link");
  l.id="pv-sp-css";l.rel="stylesheet";
  l.href=window.__pvSearchCSSUrl||"";
  if(l.href)document.head.appendChild(l);
}

var panel=null,qEl=null,bodyEl=null,clrEl=null,delBarEl=null;
var collections=[],topProds=[];
var dataFetched=false,cartTotal=0;
var timer=null,liveQ="";

var toastTimer=null;
function showToast(msg){
  var t=document.getElementById("pv-sp-toast");
  if(!t){t=document.createElement("div");t.id="pv-sp-toast";document.body.appendChild(t)}
  t.textContent=msg;t.className="pv-sp-toast-in";
  clearTimeout(toastTimer);
  toastTimer=setTimeout(function(){t.className=""},2200);
}

function fetchCart(cb){
  fetch("/cart.js",{headers:{Accept:"application/json"}})
    .then(function(r){return r.json()})
    .then(function(d){cartTotal=d.total_price||0;if(cb)cb()})
    .catch(function(){if(cb)cb()});
}

function renderDelBar(){
  if(!delBarEl)return;
  var rem=FREE_DEL-cartTotal;
  var pct=cartTotal>=FREE_DEL?100:Math.max(4,Math.round(cartTotal/FREE_DEL*100));
  var isFree=rem<=0;
  delBarEl.innerHTML='<div class="pv-sp-del'+(isFree?" pv-sp-del--free":"")+'">'+'<div class="pv-sp-del-txt">'+(isFree?"🎉 \xA1Domicilio <strong>GRATIS</strong> desbloqueado!":"Agregá <strong>"+fmtC(rem)+"</strong> más para <strong>domicilio GRATIS</strong> 🛵")+'</div>'+'<div class="pv-sp-del-track"><div class="pv-sp-del-fill" style="width:'+pct+'%"></div></div>'+'</div>';
}

function fetchData(){
  if(dataFetched)return;dataFetched=true;
  fetch("/collections.json?limit=25",{headers:{Accept:"application/json"}})
    .then(function(r){return r.json()})
    .then(function(d){
      collections=(d.collections||[]).filter(function(c){
        return c.handle&&c.handle!=="all"&&c.handle!=="frontpage"&&c.handle!=="hidden";
      }).slice(0,10);
      refreshEmpty();
    }).catch(function(){});
  fetch("/collections/los-mas-vendidos/products.json?limit=4",{headers:{Accept:"application/json"}})
    .then(function(r){if(!r.ok)throw 0;return r.json()})
    .then(function(d){topProds=(d.products||[]).slice(0,4);refreshEmpty()})
    .catch(function(){
      fetch("/collections/all/products.json?limit=4&sort_by=best-selling",{headers:{Accept:"application/json"}})
        .then(function(r){return r.json()})
        .then(function(d){topProds=(d.products||[]).slice(0,4);refreshEmpty()})
        .catch(function(){});
    });
}

function refreshEmpty(){
  if(panel&&panel.classList.contains("pv-sp--open")&&!liveQ)renderEmpty();
}

function buildPanel(){
  if(document.getElementById("pv-sp"))return;
  panel=document.createElement("div");
  panel.id="pv-sp";
  panel.setAttribute("role","dialog");
  panel.setAttribute("aria-modal","true");
  panel.setAttribute("aria-label","Buscar productos");
  panel.innerHTML=
    '<div class="pv-sp-head">'+
      '<div class="pv-sp-iw">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'+
        '<input class="pv-sp-q" type="search" placeholder="Buscar productos..." autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">'+
        '<button type="button" class="pv-sp-clr" aria-label="Limpiar">\xD7</button>'+
      '</div>'+
      '<button type="button" class="pv-sp-cancel">Cancelar</button>'+
    '</div>'+
    '<div class="pv-sp-delbar"></div>'+
    '<div class="pv-sp-body"></div>';
  document.body.appendChild(panel);
  qEl=panel.querySelector(".pv-sp-q");
  bodyEl=panel.querySelector(".pv-sp-body");
  clrEl=panel.querySelector(".pv-sp-clr");
  delBarEl=panel.querySelector(".pv-sp-delbar");
  panel.querySelector(".pv-sp-cancel").addEventListener("click",closePanel);
  clrEl.addEventListener("click",function(){
    qEl.value="";liveQ="";clrEl.classList.remove("show");
    renderEmpty();qEl.focus();
  });
  qEl.addEventListener("input",function(){
    var q=(this.value||"").trim();liveQ=q;
    clrEl.classList.toggle("show",q.length>0);
    clearTimeout(timer);
    if(q.length<1)renderEmpty();
    else timer=setTimeout(function(){renderSkel();doSearch(q)},280);
  });
  qEl.addEventListener("keydown",function(e){
    if(e.key==="Enter"){
      var q=(this.value||"").trim();
      if(q.length>=1){addRecent(q);location.href="/search?q="+encodeURIComponent(q)+"&type=product"}
    }
  });
  document.addEventListener("keydown",function(e){
    if(e.key==="Escape"&&panel&&panel.classList.contains("pv-sp--open"))closePanel();
  });
}

function openPanel(){
  buildPanel();fetchData();
  liveQ="";if(qEl)qEl.value="";
  if(clrEl)clrEl.classList.remove("show");
  panel.classList.add("pv-sp--open");
  document.body.style.overflow="hidden";
  fetchCart(function(){renderDelBar();renderEmpty()});
  setTimeout(function(){if(qEl)qEl.focus()},300);
}

function closePanel(){
  if(!panel)return;
  panel.classList.remove("pv-sp--open");
  document.body.style.overflow="";liveQ="";
}

function skRow(){
  return'<div class="pv-sp-skel"><div class="pv-sp-skel-img"></div><div class="pv-sp-skel-txt"><div class="pv-sp-skel-line"></div><div class="pv-sp-skel-line"></div></div></div>';
}
function renderSkel(){if(!bodyEl)return;bodyEl.innerHTML=skRow()+skRow()+skRow()}

function prodRow(p,idx,q){
  var img=shopImg((p.images&&p.images[0]&&p.images[0].src)||p.image||"",100);
  var vid=(p.variants&&p.variants[0]&&p.variants[0].id)||"";
  var rawPrice=(p.variants&&p.variants[0]&&p.variants[0].price)||p.price||"";
  var price=rawPrice?fmtP(rawPrice):"";
  var badge=idx<BADGES.length?'<div class="pv-sp-prod-badge">'+BADGES[idx]+'</div>':"";
  var name=q?hl(p.title,q):escH(p.title);
  var url=p.url||(p.handle?"/products/"+p.handle:"");
  var lo=url?'<a class="pv-sp-prod-link" href="'+escH(url)+'">':'<div class="pv-sp-prod-link">';
  var lc=url?"</a>":"</div>";
  return'<div class="pv-sp-prod">'+
    lo+
    (img?'<img class="pv-sp-prod-img" src="'+img+'" alt="" loading="lazy">':'<div class="pv-sp-prod-img"></div>')+
    '<div class="pv-sp-prod-info">'+badge+
      '<div class="pv-sp-prod-name">'+name+'</div>'+
      '<div class="pv-sp-prod-price">'+price+'</div>'+
    '</div>'+
    lc+
    (vid?'<button type="button" class="pv-sp-add" data-vid="'+vid+'" aria-label="Agregar">+</button>':'')+
  '</div>';
}

function renderEmpty(){
  if(!bodyEl)return;
  var html='<div class="pv-sp-sec">🔥 Populares</div><div class="pv-sp-trend">';
  TRENDING.forEach(function(t){html+='<button type="button" class="pv-sp-trend-tag" data-q="'+escH(t)+'">'+escH(t)+'</button>';});
  html+='</div>';
  if(collections.length>0){
    html+='<div class="pv-sp-sec">Categor\xEDas</div><div class="pv-sp-cats">';
    collections.forEach(function(c){var em=catEmoji(c.title);html+='<a class="pv-sp-cat" href="/collections/'+c.handle+'">'+(em?em+" ":"")+escH(c.title)+'</a>';});
    html+='</div>';
  }
  html+='<div class="pv-sp-sec">Los m\xE1s pedidos</div>';
  if(topProds.length>0){
    topProds.forEach(function(p,i){html+=prodRow(p,i,null)});
  }else{html+=skRow()+skRow()+skRow()}
  var rec=getRecent();
  if(rec.length>0){
    html+='<div class="pv-sp-rec-bar"><div class="pv-sp-sec" style="margin:0">Tus b\xFAsquedas recientes</div><button type="button" class="pv-sp-clr-all">BORRAR</button></div><div class="pv-sp-rec-list">';
    rec.forEach(function(r){html+='<button type="button" class="pv-sp-rec-tag" data-q="'+escH(r)+'">'+escH(r)+'</button>';});
    html+='</div>';
  }
  bodyEl.innerHTML=html;wireBody();
}

function doSearch(q){
  if(!bodyEl)return;
  fetch("/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product,collection&resources[limit]=6",{headers:{Accept:"application/json"}})
    .then(function(r){return r.json()})
    .then(function(d){
      if(liveQ!==q)return;
      var res=(d.resources&&d.resources.results)||{};
      var prods=res.products||[];
      var colls=res.collections||[];
      var html="";
      if(colls.length>0){
        html+='<div class="pv-sp-sec">Categor\xEDas</div>';
        colls.forEach(function(c){var em=catEmoji(c.title);html+='<a class="pv-sp-coll-a" href="'+escH(c.url)+'">'+(em?em+"\xA0":"")+hl(c.title,q)+'</a>';});
      }
      if(prods.length>0){
        html+='<div class="pv-sp-sec">Productos</div>';
        prods.forEach(function(p,i){html+=prodRow(p,i,q)});
        addRecent(q);
        html+='<a class="pv-sp-see-all" href="/search?q='+encodeURIComponent(q)+'&type=product">Ver todos los resultados de "'+escH(q)+'" →</a>';
      }
      if(!prods.length&&!colls.length){
        html='<div class="pv-sp-mt"><div class="pv-sp-mt-icon">🤷</div>No encontramos "<strong>'+escH(q)+'</strong>"<br><small>Probá con otro término o explorá el menú</small></div>';
      }
      bodyEl.innerHTML=html;wireBody();
    }).catch(function(){
      if(liveQ===q)bodyEl.innerHTML='<div class="pv-sp-mt">Error al buscar. Intentá de nuevo.</div>';
    });
}

function addToCart(vid,btn){
  btn.disabled=true;
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:vid,quantity:1})})
    .then(function(r){if(!r.ok)throw 0;return r.json()})
    .then(function(){
      btn.textContent="✓";btn.classList.add("done");
      try{if(navigator.vibrate)navigator.vibrate([30])}catch(e){}
      fetch("/cart/count.json",{headers:{Accept:"application/json"}})
        .then(function(r){return r.json()})
        .then(function(d){document.querySelectorAll(".cart-count-bubble [aria-hidden='true'],.cart-count-bubble span:not(.visually-hidden)").forEach(function(el){el.textContent=d.count})})
        .catch(function(){});
      fetchCart(function(){renderDelBar()});
      try{if(window.pvOrderBarRefresh)window.pvOrderBarRefresh()}catch(e){}
      showToast("✓ Agregado al carrito");
      setTimeout(function(){btn.textContent="+";btn.classList.remove("done");btn.disabled=false},2000);
    }).catch(function(){
      btn.textContent="+";btn.disabled=false;
      showToast("Error al agregar. Intentá de nuevo.");
    });
}

function wireBody(){
  bodyEl.querySelectorAll(".pv-sp-add[data-vid]").forEach(function(btn){
    btn.addEventListener("click",function(){var vid=parseInt(this.dataset.vid)||0;if(vid&&!this.disabled)addToCart(vid,this)});
  });
  bodyEl.querySelectorAll(".pv-sp-trend-tag[data-q],.pv-sp-rec-tag[data-q]").forEach(function(btn){
    btn.addEventListener("click",function(){var q=this.dataset.q;if(qEl){qEl.value=q;if(clrEl)clrEl.classList.add("show")}liveQ=q;renderSkel();doSearch(q)});
  });
  var ca=bodyEl.querySelector(".pv-sp-clr-all");
  if(ca)ca.addEventListener("click",function(){clearRecent();renderEmpty()});
}

function interceptSearch(){
  document.addEventListener("click",function(e){
    if(!e.target)return;
    var t=e.target.closest(".header__icon--search,.search-modal__open-button,[data-open='search-modal'],a[href*='/search']:not([href*='?q=']),button[aria-label*='earch'],a[aria-label*='earch']");
    if(!t)return;
    e.preventDefault();e.stopImmediatePropagation();openPanel();
  },true);
  var sd=document.querySelector("details.search-modal");
  if(sd){
    new MutationObserver(function(){
      if(sd.hasAttribute("open")){sd.removeAttribute("open");openPanel();}
    }).observe(sd,{attributes:true,attributeFilter:["open"]});
  }
}

injectCSS();
if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",interceptSearch);
}else{
  interceptSearch();
}
document.addEventListener("shopify:section:load",function(){setTimeout(interceptSearch,200)});

})();